module.exports = __webpack_public_path__ + "img/couples_11_V.3e86e6d2.webp";